export default {
  dateLabel: {
    id: 'processout_card_adapter_date_label',
    defaultMessage: 'Expiration date',
  },
  datePlaceholder: {
    id: 'processout_card_adapter_date_placeholder',
    defaultMessage: 'mm / yy',
  },
  numberLabel: {
    id: 'processout_card_adapter_number_label',
    defaultMessage: 'Card number',
  },
  securityCodeLabel: {
    id: 'processout_card_adapter_security_code_label',
    defaultMessage: 'CVV',
  },
  securityCodeHelpButton: {
    id: 'processout_card_adapter_security_code_help_button',
    defaultMessage: 'What is the CVV?',
  },
}
